// extracted by mini-css-extract-plugin
export default {"section-list-item":"sectionListItem_section-list-item__R77Xa","section-link":"sectionListItem_section-link__fkcbl"};